import React from "react";
import * as styles from "./ArticleCard.module.scss";
import { Typography } from "..";
import { Link } from "@components/";
import classNames from "classnames";
import { CmsNode } from "@components/CMS/CmsTypes";
import CmsFeaturedImage from "@components/CMS/components/CmsFeaturedImage/CmsFeaturedImage";

export type ArticleCardProps = {
	data: CmsNode;
	mini?: boolean;
};

export default function ArticleCard({
	data,
	mini = false,
}: ArticleCardProps): JSX.Element {
	const {
		title,
		created,
		body: { summary },
		path: { alias: link },
	} = data;
	let card = (
		<div
			className={classNames(styles.container, {
				[styles.featuredContainer]: !mini,
			})}
		>
			<CmsFeaturedImage className={styles.image} node={data} />
			<div className={styles.right}>
				<Typography className={styles.date}>{created}</Typography>
				<Typography className={styles.title}>{title}</Typography>
				<Typography className={styles.summary}>{summary}</Typography>
			</div>
		</div>
	);

	if (link) {
		card = (
			<Link to={link} internal={false}>
				{card}
			</Link>
		);
	}

	return <>{card}</>;
}
